
import { Component, Vue, Prop } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { RegionDto } from "../../dtos/regionDto";
import rules from "@/store/rules";
import { PriceModel } from "@/dtos/priceModel";
import { PriceSettingsDto } from "@/dtos/priceSettingDto";
import { RegionPowderDto } from "@/dtos/regionPowderDto";
import PowderFinishes from "@/dtos/IPowderFinish";
import { IPowderFinish } from "@/dtos/IPowderFinish";
import PowderStructures from "@/dtos/IPowderStructure";
import { IPowderStructure } from "@/dtos/IPowderStructure";
import PowderApplications from "@/dtos/IPowderApplication";
import { IPowderApplication } from "@/dtos/IPowderApplication";
import { PowderStructure } from "@/dtos/powderStructure";
import { PowderFinish } from "@/dtos/powderFinish";
import { HolidayTypeDto } from "@/dtos/holidayTypeDto";

@Component
export default class CalcSettings extends Vue {
	private loading: boolean = false;
	private loadingPowder: boolean = false;
	private openExpand: number | null = null;
	private regionOpenExpand: number | null = null;
	private regionSettings: RegionDto[] = new Array<RegionDto>();
	private holidayTypes: HolidayTypeDto[] = new Array<HolidayTypeDto>();
	private holidayOpenExpand: number | null = null;
	private requiredRule = rules.requiredRule;
	private requiredNonNegativeIntegerRule = rules.requiredNonNegativeIntegerRule;
	private optionalNonNegativeIntegerRule = rules.optionalNonNegativeIntegerRule;
	private requiredNonNegativeNumberRule = rules.requiredNonNegativeNumberRule;
	private optionalNonNegativeNumberRule = rules.optionalNonNegativeNumberRule;
	private requiredNumber0To1Rule = rules.requiredNumber0To1Rule;
	private optionalNumber0To1Rule = rules.optionalNumber0To1Rule;
	private requiredNumberBiggerEqual1Rule = rules.requiredNumberBiggerEqual1Rule;
	private editPowderDialog: boolean = false;
	private currentPowderRegionId: number = 0;
	private regionPowders: RegionPowderDto[] = new Array<RegionPowderDto>();
	private powderFinishes: IPowderFinish[] = PowderFinishes;
	private powderStructures: IPowderStructure[] = PowderStructures;
	private powderApplications: IPowderApplication[] = PowderApplications;
	private ralFilterTerm: string = "";
	private showStructureFein: boolean = true;
	private showStructureGrob: boolean = true;
	private showStructureGlatt: boolean = true;
	private showFinishMatt: boolean = true;
	private showFinishGlaenzend: boolean = true;
	private powderHeaders: any = [
		{
			text: "Pulver",
			sortable: false,
		},
		{
			text: "Verfügbar",
			sortable: false,
		},
		{
			text: "Einrichtungs-Faktor",
			sortable: false,
		},
	];

	private async mounted() {
		await this.loadSettings();
		// Validate all the forms
		(this.$refs.formRegion as any).forEach((form: any) => form.validate());
		(this.$refs.formAllgemein as any).forEach((form: any) => form.validate());
		(this.$refs.formNcprogramm as any).forEach((form: any) => form.validate());
		(this.$refs.formSchneiden as any).forEach((form: any) => form.validate());
		(this.$refs.formBiegen as any).forEach((form: any) => form.validate());
		(this.$refs.formEntgraten as any).forEach((form: any) => form.validate());
		(this.$refs.formFeatures as any).forEach((form: any) => form.validate());
		(this.$refs.formPulverbeschichten as any).forEach((form: any) => form.validate());
		(this.$refs.formVerzinken as any).forEach((form: any) => form.validate());
		(this.$refs.formTeilehandling as any).forEach((form: any) => form.validate());
		(this.$refs.formVerpacken as any).forEach((form: any) => form.validate());
		(this.$refs.formZertifikat as any).forEach((form: any) => form.validate());
		(this.$refs.formStornieren as any).forEach((form: any) => form.validate());
	}

	private get validForms(): boolean {
		return this.regionSettings.every(
			(rs: RegionDto) =>
				rs.valid &&
				rs.priceSettings.every(
					(ps: PriceSettingsDto) =>
						ps.validNcProgramm &&
						ps.validSchneiden &&
						ps.validBiegen &&
						ps.validEntgraten &&
						ps.validFeatures &&
						ps.validPulverbeschichten &&
						ps.validVerzinken &&
						ps.validTeilehandling &&
						ps.validZertifikat &&
						ps.validAllgemein &&
						ps.validVerpacken &&
						ps.validStornieren
				)
		);
	}

	private isStandard(priceModel: PriceModel) {
		return priceModel == PriceModel.Standard;
	}

	private getEnumNameFromValue(enumValue: number) {
		return PriceModel[enumValue];
	}

	private getPlaceholder(regionId: number, propertyName: string) {
		let standardSettings: PriceSettingsDto = this.regionSettings
			.filter((r: RegionDto) => r.id == regionId)[0]
			.priceSettings.filter((s: PriceSettingsDto) => s.priceModel == PriceModel.Standard)[0];
		let standardPropValue = standardSettings[propertyName as keyof PriceSettingsDto];
		return `Erbt von Standard: ${standardPropValue}`;
	}

	private getRegionSettings(regionId: number) {
		return this.regionSettings.filter((r: RegionDto) => r.id === regionId)[0];
	}

	private GetStructureString(enumValue: number) {
		return this.powderStructures.filter((type: IPowderStructure) => type.value == enumValue)[0]
			.text;
	}
	private GetFinishString(enumValue: number) {
		return this.powderFinishes.filter((type: IPowderFinish) => type.value == enumValue)[0].text;
	}
	private GetApplicationString(enumValue: number) {
		return this.powderApplications.filter(
			(type: IPowderApplication) => type.value == enumValue
		)[0].text;
	}

	private get filteredPowders() {
		if (!this.regionPowders || this.regionPowders.length <= 0) return [];
		let filtered = this.regionPowders.filter(
			(p: RegionPowderDto) =>
				(this.ralFilterTerm.length <= 0 ||
					p.surfaceColor.ralCode.includes(this.ralFilterTerm)) &&
				(this.showStructureFein || p.structure != PowderStructure.Fine) &&
				(this.showStructureGlatt || p.structure != PowderStructure.Smooth) &&
				(this.showStructureGrob || p.structure != PowderStructure.Rough) &&
				(this.showFinishGlaenzend || p.finish != PowderFinish.Glossy) &&
				(this.showFinishMatt || p.finish != PowderFinish.Matt)
		);

		filtered = filtered.sort((c1: RegionPowderDto, c2: RegionPowderDto) => {
			if (c1.surfaceColor.ralCode == c2.surfaceColor.ralCode) {
				if (c1.structure === c2.structure) {
					return c1.finish - c2.finish;
				} else {
					return c1.structure - c2.structure;
				}
			} else {
				return parseInt(c1.surfaceColor.ralCode) - parseInt(c2.surfaceColor.ralCode);
			}
		});

		return filtered;
	}

	private async openPowderEditDialog(regionId: number) {
		try {
			this.loading = true;
			this.loadingPowder = true;
			if (this.regionPowders.length <= 0 || this.currentPowderRegionId !== regionId) {
				const settings = await httpClient().get(
					`Region/GetRegionPowders?regionId=${regionId}`
				);
				this.regionPowders = settings.data;
				this.currentPowderRegionId = regionId;
			}
			this.editPowderDialog = true;
		} catch {
			console.log("Loading regional powders failed.");
		} finally {
			this.loading = false;
			this.loadingPowder = false;
		}
	}

	private async updateRegionPowder(powder: RegionPowderDto) {
		if (isNaN(powder.setupPriceFactor) || powder.setupPriceFactor < 1) {
			this.$store.commit("setSnackbarErrorText", "Einrichtungs-Faktor muss >= 1 sein.");
			return;
		}
		try {
			console.log("saving powder");
			this.loadingPowder = true;
			let powderDto = {
				powderId: powder.id,
				regionId: this.currentPowderRegionId,
				setupPriceFactor: powder.setupPriceFactor,
				available: powder.available,
			};
			await httpClient().post(`Region/UpdateRegionPowder`, powderDto);
			this.$store.commit("setSnackbarText", `Pulver #${powder.id} aktualisiert`);
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Pulver konnte nicht aktualisiert werden");
			console.log("Error while saving settings.", err);
		} finally {
			this.loadingPowder = false;
		}
	}

	private async loadSettings() {
		try {
			this.loading = true;
			const settings = await httpClient().get("Region/GetRegionSettings");
			this.regionSettings = settings.data;
			const holidays = await httpClient().get("Region/GetHolidayTypes");
			this.holidayTypes = holidays.data;
		} catch {
			console.log("Loading settings failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateSettings() {
		try {
			this.loading = true;
			await httpClient().post(`Region/SetRegionSettings`, this.regionSettings);
			this.$store.commit("setSnackbarText", `Einstellungen erfolgreich gespeichert.`);
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Einstellungen konnten nicht gespeichert werden."
			);
			console.log("Error while saving settings.", err);
		} finally {
			this.loading = false;
		}
	}
}
